import createWebStorage from "redux-persist/es/storage/createWebStorage";

const createSessionStorage = () => ({
  getItem: (key: string) => Promise.resolve(sessionStorage.getItem(key)),
  setItem: (key: string, value: string) => Promise.resolve(sessionStorage.setItem(key, value)),
  removeItem: (key: string) => Promise.resolve(sessionStorage.removeItem(key)),
});

const storage = typeof window !== 'undefined' 
  ? createSessionStorage() 
  : createWebStorage('session');

export default storage;
